export const NOTIFICATIONS_SERVICES_PATHNAME = "/notifications/services";
